module.exports = __webpack_public_path__ + "img/m_join_3.d4963329.png";